import { render, staticRenderFns } from "./yc-cost.vue?vue&type=template&id=274a4ab9&scoped=true&"
import script from "./yc-cost.vue?vue&type=script&lang=js&"
export * from "./yc-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a4ab9",
  null
  
)

export default component.exports